import React, { useEffect } from "react";
import _ from "lodash";

import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
import diceImg from "assets/images/ct/dice.png";
import eyeImg from "assets/images/ct/they-know-eye.png";
import line from "assets/images/ct/line.png";
import OtherPlayer from "../components/OtherPlayer";
const CTStartTurn = ({
  handleRollDiceClick,
  screens,
  isActivePlayer,
  currentPlayerInfo,
  isReaderPlayer,
  currentPlayer,
  setdice1 = () => {},
  setdice2 = () => {},
  dice1,
  dice2,
  currentPlayerCard,
  isTestingStage = false,
  buzzer_sound,
  default_audio_effect,joke
}) => {
  const instructions = _.get(
    screens,
    "2_startturn.active.instructions",
    "Roll the dice to get started, if you land on a conspiracy or corner tile prepare to be interrogated!"
  );

  const roll_the_dice = _.get(
    screens,
    "2_startturn.active.roll_the_dice",
    "ROLL THE DICE"
  );
  const title = _.get(screens, "2_startturn.active.title", "Your TURN");

  const handleInputChange = (value, setter) => {
    const sanitizedValue = value.replace(/[^0-9]/g, "");
    setter(sanitizedValue);
  };
  useEffect(() => {
    if (isActivePlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect]);
  return isActivePlayer ? (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="start-turn"
    >
      <motion.div variants={fadeVariants} className="turn-flex">
        <img src={eyeImg} className="img-fluid" alt="" />
        <div className="your-turn">
          <h3 className="title">{title}</h3>
          <img src={line} className="img-fluid line" alt="" />
        </div>
      </motion.div>
      <motion.p variants={fadeVariants} className="info">
        {instructions}
      </motion.p>
        <div className="roll-the-dice">
        {isTestingStage && (
        <input
          type="text"
          placeholder="dice 1 value "
          value={dice1}
          onChange={(e) => handleInputChange(e.target.value, setdice1)}
        />
      )}
      {isTestingStage && (
        <input
          type="text"
          placeholder="dice 2 value "
          value={dice2}
          onChange={(e) => handleInputChange(e.target.value, setdice2)}
        />
      )}
        </div>
    
      <motion.div
        variants={staticBounceVariants}
        className="dice-wrapper"
        onClick={handleRollDiceClick}
      >
        <img src={diceImg} className="dice img-fluid" alt="" />
        <p className="dice-txt">{roll_the_dice}</p>
      </motion.div>
    </motion.div>
  ) : (
    <OtherPlayer
      screens={screens}
      isReaderPlayer={isReaderPlayer}
      currentPlayerInfo={currentPlayerInfo}
      currentPlayerCard={currentPlayerCard}
      currentPlayer={currentPlayer}
      joke={joke}
    />
  );
};

export default CTStartTurn;
